import { useEffect, useState } from "react"
import { Button, Modal } from "react-bootstrap"
import { JTable, JTBody, JTHead } from "../../../../components/Components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDoorClosed } from "@fortawesome/free-solid-svg-icons";
import manifestoService from "../../../../services/ManifestoService";

interface ListaProps {
    id: string;
    show: boolean;
    onHide: () => void;
}
export const ModalListaDFe: React.FC<ListaProps> = ({ id, show, onHide }) => {
    const [lista, setLista] = useState<any[]>([]);


    useEffect(() => {
        manifestoService.getListaDFesIncluidos(id).then(res => {
            setLista(res);
        }).catch(error => {
            console.log(error);
        })
    }, []);


    return (<>
        <Modal size="lg" centered backdrop='static' show={show} onHide={() => { onHide(); }}>
            <Modal.Header closeButton className="bg-success-subtle border-2 border-success py-2">
                <Modal.Title className="h6">Lista de DF-es incluídos</Modal.Title>
            </Modal.Header>
            <Modal.Body >
                {lista.length > 0 && (
                    <JTable className="caption-top mb-1 border border-2 border-success rounded-2 table table-sm table-striped table-bordered">
                        <JTHead>
                            <tr>
                                <th rowSpan={2} className="text-center" style={{ alignContent: 'center' }}>
                                    Municipio de Carregamento
                                </th>
                                <th colSpan={2} className="text-center">Inclusões de DF-es</th>
                            </tr>
                            <tr>
                                <th rowSpan={2} className="text-center">Mun. Descarga</th>
                                <th rowSpan={2} className="text-center">Chave de acesso</th>
                            </tr>
                        </JTHead>
                        <JTBody>
                            {lista.map((item: any) => (
                                <>
                                    {item.nfes?.map((n: any, index: number) => (
                                        <tr key={`${item.id}-${n.chNFe}`}>
                                            {index === 0 && (
                                                <td rowSpan={item.nfes?.length || 1}>{item.xMunCarrega}</td>
                                            )}
                                            <td >{n.xMunDescarga}</td>
                                            <td>{n.chNFe}</td>
                                        </tr>
                                    ))}
                                </>
                            ))}
                        </JTBody>
                    </JTable>
                )}
            </Modal.Body>

            <Modal.Footer className="py-1">
                <Button variant="secondary" onClick={() => onHide()}>
                    <FontAwesomeIcon icon={faDoorClosed} /> Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    </>)
}